<mat-card style="border-color: #5775a8;">
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full" style="align-items: center;">
      <div class="flex flex-col w-full" style="padding-right: 20px;">
        <h4 style="color:white;"><b>Edit Correspondence</b></h4>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">

      <div class="flex flex-col w-full">
        <br />
        <div class="flex flex-col w-full">
          <span>Title: {{correspondence.title}}</span>
        </div>
        <br />
        <div>
          <span>Type: {{getType(correspondence.typeId)}}</span>
        </div>
        <br />
        <div>
          <mat-form-field>
            <mat-label>Generated Date</mat-label>
            <input matInput [matDatepicker]="generatedDate" formControlName="generatedDate">
            <mat-datepicker-toggle matSuffix [for]="generatedDate"></mat-datepicker-toggle>
            <mat-datepicker #generatedDate></mat-datepicker>
            <mat-error *ngIf="form.get('generatedDate').invalid">
              Required: Invalid or future date.
            </mat-error>
          </mat-form-field>

          <!-- <span>Generated: {{correspondence.generatedDate}}</span> -->
        </div>
        <br />
        <div>
          <mat-form-field>
            <mat-label>Sent Date</mat-label>
            <input matInput [matDatepicker]="sentDate" formControlName="sentDate">
            <mat-datepicker-toggle matSuffix [for]="sentDate"></mat-datepicker-toggle>
            <mat-datepicker #sentDate></mat-datepicker>
            <mat-error *ngIf="form.get('sentDate').invalid">
              Invalid or future date.
            </mat-error>
          </mat-form-field>

        </div>
        <div class="flex flex-col w-full">

          <mat-checkbox formControlName="discardedCorrespondence">
            <span>Discarded Correspondence</span>
          </mat-checkbox>

        </div>
        <div class="flex flex-col w-full">

          <mat-checkbox formControlName="invalidAddress">
            <span>Invalid Address</span>
          </mat-checkbox>


        </div>
        <div class="flex flex-col w-full">
          <span>Complaint ID: {{correspondence.complaintId}}</span>
        </div>
        <br />
        <div class="flex flex-row w-full">
          <div>
            <button mat-raised-button (click)="save()" style="background: #7ABDF3;">
              <mat-icon>save</mat-icon> Save
            </button>
          </div>
          <div style="padding-left: 20px;">
            <button mat-raised-button (click)="return()" style="padding-right: 20px;">
              Return
            </button>
          </div>
        </div>

      </div>
    </form>

  </mat-card-content>

</mat-card>